import useFetch from 'utils/hooks/useFetch'
import { 
    ApiDeleteBank,
    ApiDeleteBeneficiaryAccount, 
    ApiDeleteCustomer, 
    ApiDeleteCustomerCard, 
    ApiDeleteEdc, 
    ApiDeleteSettlement, 
    ApiDeleteTransaction, 
    ApiDeleteUser, 
    ApiGetBank, 
    ApiGetBankList, 
    ApiGetBeneficiaryAccount, 
    ApiGetBeneficiaryAccountList, 
    ApiGetCardVendorList, 
    ApiGetCashInList, 
    ApiGetCommonByKey, 
    ApiGetCustomer, 
    ApiGetCustomerCard, 
    ApiGetCustomerCardList, 
    ApiGetCustomerList, 
    ApiGetCustomerPaymentById, 
    ApiGetCustomerPaymentList, 
    ApiGetCustomerPaymentSummary, 
    ApiGetEdc, 
    ApiGetEdcBankList, 
    ApiGetEdcList, 
    ApiGetLocationList, 
    ApiGetPaymentReceived, 
    ApiGetSettlementById, 
    ApiGetSettlementList, 
    ApiGetTransaction, 
    ApiGetTransactionCustomerCard, 
    ApiGetTransactionList, 
    ApiGetTransactionReportEdc, 
    ApiGetTransferPLList, 
    ApiGetUser, 
    ApiGetUserList, 
    ApiInsertBank, 
    ApiInsertBeneficiaryAccount, 
    ApiInsertCustomer, 
    ApiInsertCustomerCard, 
    ApiInsertEdc, 
    ApiInsertSettlement, 
    ApiInsertTransaction, 
    ApiPaySettlement, 
    ApiProceedPayment, 
    ApiRegister, 
    ApiSettlementTransaction, 
    ApiUpdateBank, 
    ApiUpdateBeneficiaryAccount, 
    ApiUpdateCustomer, 
    ApiUpdateCustomerCard,
    ApiUpdateCustomerPayment,
    ApiUpdateEdc,
    ApiUpdatePaymentReceived,
    ApiUpdateSettlement,
    ApiUpdateTransaction,
    ApiUpdateUser
} from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import moment from 'moment'
import { InsertDateFormat } from 'utils/Constant'
import { useModal } from 'utils/context/ModalContext'

export function useCallApi() {
    const { showFail } = useModal()

    // Bank
    const { fetch: getBankList } = useFetch(ApiGetBankList)
    const { fetch: insertBank } = useFetch(ApiInsertBank)
    const { fetch: updateBank } = useFetch(ApiUpdateBank)
    const { fetch: deleteBank } = useFetch(ApiDeleteBank)
    const { fetch: getBank } = useFetch(ApiGetBank)

    // Beneficiary
    const { fetch: getBeneficiaryList } = useFetch(ApiGetBeneficiaryAccountList)
    const { fetch: deleteBeneficiary } = useFetch(ApiDeleteBeneficiaryAccount)
    const { fetch: insertBeneficiaryAccount } = useFetch(ApiInsertBeneficiaryAccount)
    const { fetch: updateBeneficiaryAccount } = useFetch(ApiUpdateBeneficiaryAccount)
    const { fetch: getBeneficiaryAccount } = useFetch(ApiGetBeneficiaryAccount)

    // Card Vendor
    const { fetch: getCardVendorList } = useFetch(ApiGetCardVendorList)

    // Customer
    const { fetch: getCustomerList } = useFetch(ApiGetCustomerList)    
    const { fetch: deleteCustomer } = useFetch(ApiDeleteCustomer)
    const { fetch: insertCustomer } = useFetch(ApiInsertCustomer)
    const { fetch: updateCustomer } = useFetch(ApiUpdateCustomer)
    const { fetch: getCustomerById } = useFetch(ApiGetCustomer)

    // Customer Card
    const { fetch: getTransactionCustomerCardList } = useFetch(ApiGetTransactionCustomerCard)
    const { fetch: getCustomerCard } = useFetch(ApiGetCustomerCard)
    const { fetch: getCustomerCardList } = useFetch(ApiGetCustomerCardList)
    const { fetch: deleteCustomerCard } = useFetch(ApiDeleteCustomerCard)
    const { fetch: insertCustomerCard } = useFetch(ApiInsertCustomerCard)
    const { fetch: updateCustomerCard } = useFetch(ApiUpdateCustomerCard)
    
    // EDC
    const { fetch: getEdcList } = useFetch(ApiGetEdcList)
    const { fetch: getEdcBankList } = useFetch(ApiGetEdcBankList)
    const { fetch: apiInsertEdc } = useFetch(ApiInsertEdc)
    const { fetch: apiUpdateEdc } = useFetch(ApiUpdateEdc)
    const { fetch: apiGetEdc } = useFetch(ApiGetEdc)

    // Transaction
    const { fetch: getTransactionList } = useFetch(ApiGetTransactionList)
    const { fetch: insertTransaction } = useFetch(ApiInsertTransaction)
    const { fetch: deleteTransaction } = useFetch(ApiDeleteTransaction)
    const { fetch: apiUpdateTransaction } = useFetch(ApiUpdateTransaction)
    const { fetch: apiGetTransaction } = useFetch(ApiGetTransaction)

    const { fetch: apiGetCustomerPaymentList } = useFetch(ApiGetCustomerPaymentList)
    const { fetch: apiProceedPayment } = useFetch(ApiProceedPayment)
    const { fetch: apiGetCustomerPaymentSummary } = useFetch(ApiGetCustomerPaymentSummary)
    const { fetch: apiGetCashIn } = useFetch(ApiGetCashInList)
    const { fetch: apiGetTransferPL } = useFetch(ApiGetTransferPLList)

    const { fetch: apiGetPaymentReceived } = useFetch(ApiGetPaymentReceived)
    const { fetch: apiUpdatePaymentReceived } = useFetch(ApiUpdatePaymentReceived)
    const { fetch: apiGetTransactionReportEdc } = useFetch(ApiGetTransactionReportEdc)
    const { fetch: apiDeleteEdc } = useFetch(ApiDeleteEdc)
    const { fetch: apiGetCustomerPaymentById } = useFetch(ApiGetCustomerPaymentById)
    const { fetch: apiUpdateCustomerPayment } = useFetch(ApiUpdateCustomerPayment)

    const { fetch: apiGetLocationList } = useFetch(ApiGetLocationList)
    
    const { fetch: apiGetCommonByKey } = useFetch(ApiGetCommonByKey)

    // User
    const { fetch: apiGetUserList } = useFetch(ApiGetUserList)
    const { fetch: apiDeleteUser } = useFetch(ApiDeleteUser)
    const { fetch: apiRegister } = useFetch(ApiRegister)
    const { fetch: apiUpdateUser } = useFetch(ApiUpdateUser)
    const { fetch: apiGetUser } = useFetch(ApiGetUser)

    // Settlement
    const { fetch: apiInsertSettlement } = useFetch(ApiInsertSettlement)
    const { fetch: apiUpdateSettlement } = useFetch(ApiUpdateSettlement)
    const { fetch: apiDeleteSettlement } = useFetch(ApiDeleteSettlement)
    const { fetch: apiGetSettlementById } = useFetch(ApiGetSettlementById)
    const { fetch: apiGetSettlementList } = useFetch(ApiGetSettlementList)
    const { fetch: apiPaySettlement } = useFetch(ApiPaySettlement)
    const { fetch: apiSettlementTransaction } = useFetch(ApiSettlementTransaction)

    // ===================================================================================================

    // Bank
    const fetchBankList = async (bankCode, bankName, status, pageSize, pageIndex) => {
        const res = await getBankList({
            data: {
                bankCode,
                bankName, 
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchInsertBank(bankCode, bankName, callCenter){
        const res = await insertBank({
            data:{
                bankCode,
                bankName, 
                callCenter
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchUpdateBank(bankId, bankCode, bankName, callCenter){
        const res = await updateBank({
            data:{
                bankId,
                bankCode,
                bankName,
                callCenter
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchDeleteBank(bankId, status){
        const res = await deleteBank({
            data:{
                bankId,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchBankById(bankId){
        const res = await getBank({
            data: {
                bankId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Beneficiary
    const fetchBeneficiaryList = async (accountNo, accountName, bankId, status, pageSize, pageIndex) => {
        const res =  await getBeneficiaryList({
            data: {
                accountNo,
                accountName, 
                bankId,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteBeneficiary = async (beneficiaryId, status) => {
        const res = await deleteBeneficiary({
            data: {
                beneficiaryId,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchBeneficiaryAccountById = async (beneficiaryId) => {
        const res = await getBeneficiaryAccount({
            data: {
                beneficiaryId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertBeneficiaryAccount = async (accountName, accountNo, bankId) => {
        const res = await insertBeneficiaryAccount({
            data:{
                accountName,
                accountNo,
                bankId
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateBeneficiaryAccount = async (beneficiaryId, accountName, accountNo, bankId) => {
        const res = await updateBeneficiaryAccount({
            data:{
                beneficiaryId,
                accountNo,
                accountName,
                bankId
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Card Vendor
    const fetchCardVendorList = async (cardVendorName, status, pageSize, pageIndex) => {
        const res = await getCardVendorList({
            data: {
                cardVendorName,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Customer
    const fetchCustomerList = async(customerName, address, phone, status, pageSize, pageIndex) => {
        const res =  await getCustomerList({
            data: {
                customerName,
                address, 
                phone,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteCustomer = async(customerId, status) => {
        const res = await deleteCustomer({
            data: {
                customerId,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerById = async (customerId) => {
        const res = await getCustomerById({
            data: {
                customerId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertCustomer = async (customerName, address, phone, idPhoto) => {
        let data = new FormData()

        data.append('CustomerName', customerName)
        data.append('Address', address)
        data.append('Phone', phone)
        data.append('IdPhoto', idPhoto)

        const res = await insertCustomer({ 
            data, 
            headers: {
                'Content-type': 'multipart/form-data'
            } 
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateCustomer = async (customerId, customerName,address, phone, idPhoto) => {
        let data = new FormData()

        data.append('CustomerId', customerId)
        data.append('CustomerName', customerName)
        data.append('Address', address)
        data.append('Phone', phone)
        data.append('IdPhoto', idPhoto)

        const res = await updateCustomer({ 
            data, 
            headers: {
                'Content-type': 'multipart/form-data'
            } 
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Customer Card
    const fetchTransactionCustomerCardList = async(customerName, cardNumber, bankId, cardVendorId, status, pageSize, pageIndex) => {
        const res =  await getTransactionCustomerCardList({
            data: {
                customerName,
                cardNumber,
                bankId,
                cardVendorId,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerCardById = async(customerCardId) => {
        const res =  await getCustomerCard({
            data: {
                customerCardId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerCardList = async (customerName, cardNumber, bankId, cardVendorId, status, pageSize, pageIndex) => {
        const res = await getCustomerCardList({
            data: {
                customerName,
                cardNumber,
                bankId,
                cardVendorId,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteCustomerCard = async (customerCardId, status) => {
        const res = await deleteCustomerCard({
            data: {
                customerCardId,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertCustomerCard = async (customerId, cardNumber, bankId, cardVendorId, expiredMonth, expiredYear, vcc, mdr) => {
        const res = await insertCustomerCard({
            data:{
                customerId,
                cardNumber,
                bankId,
                cardVendorId,
                expiredMonth,
                expiredYear,
                vcc,
                mdr
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateCustomerCard = async (customerCardId, customerId, cardNumber, bankId, cardVendorId, expiredMonth, expiredYear, vcc, mdr) => {
        const res = await updateCustomerCard({
            data:{
                customerCardId,
                customerId,
                cardNumber,
                bankId,
                cardVendorId,
                expiredMonth,
                expiredYear,
                vcc,
                mdr
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Edc
    const fetchEdcList = async(bankId, edcName, beneficiaryAccountNo, beneficiaryName, status, pageSize, pageIndex) => {
        const res =  await getEdcList({
            data: {
                bankId,
                edcName, 
                beneficiaryAccountNo,
                beneficiaryName,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchEdcBankList = async () => {
        const res = await getEdcBankList({
            data: { }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertEdc = async (bankId, edcName, beneficiaryAccountNo, mdrOn, mdrOff, mdrQrisOn, mdrQrisOff, beneficiaryId, type) => {
        const res = await apiInsertEdc({
            data:{
                bankId,
                edcName,
                beneficiaryAccountNo,
                mdrOn,
                mdrOff,
                mdrQrisOn,
                mdrQrisOff,
                beneficiaryId,
                type
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchUpdateEdc(edcId, bankId , edcName, beneficiaryAccountNo, mdrOn, mdrOff, mdrQrisOn, mdrQrisOff, beneficiaryId, type) {
        const res = await apiUpdateEdc({
            data:{
                edcId,
                bankId,
                edcName,
                beneficiaryAccountNo,
                mdrOn,
                mdrOff,
                mdrQrisOn,
                mdrQrisOff,
                beneficiaryId,
                type
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchDeleteEdc(edcId, status) {
        const res = await apiDeleteEdc({
            data:{
                edcId,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res           
    }
    async function fetchEdcById(edcId){
        const res = await apiGetEdc({
            data: {
                edcId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Transaction
    const fetchTransactionList = async(dateFrom, dateTo, customerName, cardNumber, edcId, status, pageSize, pageIndex, updateBy, locationId) =>{
        const res =  await getTransactionList({
            data: {
                dateFrom: moment(dateFrom).format(InsertDateFormat),
                dateTo: moment(dateTo).format(InsertDateFormat),
                customerName,
                cardNumber,
                edcId,
                status,
                pageSize,
                pageIndex,
                updateBy,
                locationId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchTransactionById = async (transactionId) => {
        const res = await apiGetTransaction({
            data: {
                transactionId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertTransaction = async(
        transactionDate, 
        customerCardId, 
        edcId, 
        mdrEdcOffUs, 
        mdrEdcOnUs, 
        mdrQrisOnUs, 
        mdrQrisOffUs, 
        type, 
        amount, 
        mdr, 
        netto,
        locationId,
        time, 
        paymentType, 
        transferAmount, 
        cashAmount, 
        remark, 
        beneficiaryId
    ) => {
        const res =  await insertTransaction({
            data: {
                transactionDate,
                customerCardId,
                edcId,
                mdrEdcOffUs,
                mdrEdcOnUs,
                mdrQrisOnUs,
                mdrQrisOffUs,
                type,
                amount,
                mdr,
                netto,
                locationId,
                time,
                paymentType,
                transferAmount,
                cashAmount,
                remark,
                beneficiaryId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateTransaction = async (
        transactionId,
        customerCardId, 
        transactionDate, 
        edcId, 
        mdrEdcOffUs, 
        mdrEdcOnUs, 
        mdrQrisOnUs, 
        mdrQrisOffUs, 
        type,
        amount,
        mdr, 
        netto,
        time,
        locationId
    ) => {
        const res = await apiUpdateTransaction({
            data:{
                transactionId, 
                customerCardId,
                transactionDate,
                edcId,
                mdrEdcOffUs, 
                mdrEdcOnUs, 
                mdrQrisOnUs, 
                mdrQrisOffUs, 
                type, 
                amount, 
                mdr, 
                netto,
                time,
                locationId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteTransaction = async(transactionId, status) => {
        const res =  await deleteTransaction({
            data: {
                transactionId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchTransactionReportEdc = async (dateFrom, dateTo, status) => {
        const res = await apiGetTransactionReportEdc({
            data: {
                dateFrom,
                dateTo,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    
    
    const fetchLocationList = async(locationName, status, pageSize, pageIndex) => {
        const res = await apiGetLocationList({
            data: {
                locationName,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    const fetchCustomerPaymentList = async (transactionDate, paymentStatus, status, type) => {        
        const res = await apiGetCustomerPaymentList({
            data: {
                transactionDate,
                paymentStatus,
                status,
                type
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerPaymentSummary = async (transactionDate) => {
        const res = await apiGetCustomerPaymentSummary({
            data: {
                transactionDate
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCashIn = async (cashInDate) => {
        const res = await apiGetCashIn({
            data: {
                cashInDate

            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchTransferPL = async (transferPLDate, customerName, status) => {
        const res = await apiGetTransferPL({
            data: {
                transferPLDate,
                customerName,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchProceedPayment = async (data) => {
        const res = await apiProceedPayment({
            data: data
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    const fetchUpdateCustomerPayment = async (customerPaymentId, beneficiaryId, amount, paymentBy, remark) =>{
        const res = await apiUpdateCustomerPayment({
            data:{
                customerPaymentId,
                beneficiaryId,
                amount,
                paymentBy,
                remark
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerPaymentById = async(customerPaymentId) => {
        const res = await apiGetCustomerPaymentById({
            data: {
                customerPaymentId
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    const fetchCommon = async (commonKey) => {
        const res = await apiGetCommonByKey({
            data: {
                commonKey
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }


    // User
    async function fetchUserList(username, name, status, pageSize, pageIndex) {
        const res = await apiGetUserList({
            data: {
                username,
                name, 
                status,
                pageSize,
                pageIndex
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchDeleteUser(userId, status){
        const res = await apiDeleteUser({
            data: {
                userId,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchInsertUser(username, fullName, password, isAdmin){
        const res = await apiRegister({
            data:{
                username,
                fullName,
                password,
                isAdmin
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchUpdateUser(userId, username, fullName, password, isAdmin){
        const res = await apiUpdateUser({
            data:{
                userId,
                username,
                fullName,
                password,
                isAdmin
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchUserByUserId(userId){
        const res = await apiGetUser({
            data: {
                userId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    // Settlement
    async function fetchInsertSettlement(
        settlementDate, 
        customerCardId,
        transferSourceId, 
        billingAmount, 
        mdr, 
        customerPayment, 
        settlementFee, 
        transactionAmount, 
        dueDate, 
        payCustomerPayment, 
        virtualAccountNo, 
        otherFee,
        locationId,
        remark
    ){
        const res = await apiInsertSettlement({
            data: {
                settlementDate, 
                customerCardId,
                transferSourceId, 
                billingAmount, 
                mdr, 
                customerPayment, 
                settlementFee, 
                transactionAmount, 
                dueDate, 
                payCustomerPayment, 
                virtualAccountNo, 
                otherFee,
                locationId,
                remark
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    async function fetchUpdateSettlement(
        settlementId,
        settlementDate, 
        customerCardId,
        transferSourceId, 
        billingAmount, 
        mdr, 
        customerPayment, 
        settlementFee, 
        transactionAmount, 
        dueDate, 
        payCustomerPayment, 
        virtualAccountNo, 
        otherFee,
        locationId,
        remark
    ){
        const res = await apiUpdateSettlement({
            data: {
                settlementId,
                settlementDate, 
                customerCardId,
                transferSourceId, 
                billingAmount, 
                mdr, 
                customerPayment, 
                settlementFee, 
                transactionAmount, 
                dueDate, 
                payCustomerPayment, 
                virtualAccountNo, 
                otherFee,
                locationId,
                remark
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteSettlement = async (
        settlementId,
        status
    ) => {
        const res = await apiDeleteSettlement({
            data: {
                settlementId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchSettlementById = async (
        settlementId
    ) => {
        const res = await apiGetSettlementById({
            data: {
                settlementId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchSettlementList = async (customerName, cardNumber, paymentStatus, settlementDate, status) => {
        const res = await apiGetSettlementList({
            data: {
                customerName,
                cardNumber, 
                paymentStatus, 
                settlementDate,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchPaySettlement = async (settlementId, transferSourceId, payCustomerPayment, paymentStatus, billingAmount, customerPayment, otherFee) => {
        const res = await apiPaySettlement({
            data: {
                settlementId,
                transferSourceId, 
                payCustomerPayment,
                paymentStatus,
                billingAmount,
                customerPayment,
                otherFee
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchSettlementTransaction = async (settlementId) => {
        const res = await apiSettlementTransaction({
            data: {
                settlementId,
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchBankList,                      // Bank
        fetchInsertBank,
        fetchUpdateBank,
        fetchDeleteBank,
        fetchBankById,
        fetchBeneficiaryList,               // Beneficiary
        fetchDeleteBeneficiary,
        fetchBeneficiaryAccountById,
        fetchInsertBeneficiaryAccount,
        fetchUpdateBeneficiaryAccount,
        fetchCardVendorList,                // Card Vendor
        fetchCustomerList,                  // Customer
        fetchDeleteCustomer,
        fetchCustomerById, 
        fetchInsertCustomer,
        fetchUpdateCustomer,
        fetchTransactionCustomerCardList,   // Customer Card
        fetchCustomerCardById,
        fetchCustomerCardList,
        fetchDeleteCustomerCard,
        fetchInsertCustomerCard,
        fetchUpdateCustomerCard,
        fetchEdcList,                       // EDC
        fetchEdcBankList,
        fetchInsertEdc,
        fetchUpdateEdc,
        fetchDeleteEdc,
        fetchEdcById,
        fetchTransactionList,               // Transaction
        fetchTransactionById,
        fetchInsertTransaction,
        fetchDeleteTransaction,
        fetchTransactionReportEdc,
        fetchUpdateTransaction,

        fetchCustomerPaymentList,
        fetchCustomerPaymentSummary,
        fetchCashIn,
        fetchTransferPL,
        fetchProceedPayment,

        fetchUpdateCustomerPayment,
        
        fetchCustomerPaymentById,
        fetchLocationList,
        fetchCommon,

        fetchUserList,
        fetchDeleteUser,
        fetchInsertUser,
        fetchUpdateUser,
        fetchUserByUserId,

        fetchInsertSettlement,
        fetchUpdateSettlement,
        fetchDeleteSettlement,
        fetchSettlementList,
        fetchPaySettlement,
        fetchSettlementById,
        fetchSettlementTransaction
    }
}